import React from 'react';
import styled from 'styled-components';
import { ProjectContainer, ProjectTitle, ProjectInfo } from './styles';
import { useLanguage } from '../../contexts/LanguageContext';

const ProjectDescription = styled.div`
  margin-bottom: 30px;
  line-height: 24px;
`;

const ProjectWrapper = styled.div`
  margin-bottom: 40px;
  
  h4 {
    font-size: 20px;
    color: #333;
    margin: 0 0 20px 0;
    font-weight: 600;
  }
  
  h5 {
    font-size: 16px;
    color: #333;
    margin: 20px 0 10px 0;
    font-weight: 600;
  }
  
  p {
    line-height: 24px;
    margin-bottom: 15px;
  }
  
  img {
    width: 100%;
    max-width: 600px;
    height: auto;
    margin-bottom: 20px;
    border: 1px solid #eee;
  }
  
  .seeDemo {
    text-align: center;
    margin: 20px 0;
    
    a {
      background: #F34452;
      color: #FFF;
      padding: 12px 30px;
      text-decoration: none;
      text-transform: uppercase;
      font-weight: 600;
      border-radius: 3px;
      transition: all 0.3s;
      display: inline-block;
      
      &:hover {
        background: #d63946;
      }
    }
  }
  
  ul.list-inline {
    list-style: none;
    padding: 0;
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
    
    li {
      b {
        color: #333;
      }
    }
  }
  
  .closeBtn {
    text-align: center;
    margin-top: 30px;
    
    button {
      background: #007bff;
      color: #FFF;
      border: none;
      padding: 12px 25px;
      border-radius: 3px;
      cursor: pointer;
      font-weight: 600;
      transition: all 0.3s;
      
      &:hover {
        background: #0056b3;
      }
      
      i {
        margin-right: 8px;
      }
    }
  }
`;

interface ProjectYumsoProps {
}

const ProjectYumso: React.FC<ProjectYumsoProps> = () => {
  const { t } = useLanguage();
  
  return (
    <ProjectContainer>
      <ProjectTitle>
        <h2>{t('yumso.title')}</h2>
        <p className="tags">{t('yumso.role')}</p>
      </ProjectTitle>
      
      <ProjectDescription>
        {t('yumso.description')}
      </ProjectDescription>
      
      <ProjectInfo>
        <p><b>{t('yumso.roleLabel')}</b> {t('yumso.myRole')}</p>
        <p><b>{t('yumso.skillsLabel')}</b> {t('yumso.skillsUtilized')}</p>
      </ProjectInfo>

      <ProjectWrapper>
        <h4>{t('yumso.aboutCompany')}</h4>
        <p>{t('yumso.companyDesc1')}</p>
        <p>{t('yumso.companyDesc2')}</p>
      </ProjectWrapper>

      <ProjectWrapper>
        <h4>{t('yumso.ideasStart')}</h4>
        <h5>{t('yumso.adminPanel')}</h5>
        <img loading="lazy" decoding="async" src="/images/projects/yumso04.webp" className="img-responsive" alt="admin"/>
        <h5>{t('yumso.driverWorkflow')}</h5>
        <img loading="lazy" decoding="async" src="/images/projects/yumso05.webp" className="img-responsive" alt="driver"/>
      </ProjectWrapper>

      <ProjectWrapper>
        <h4>{t('yumso.translatedIdeas')}</h4>
        <div className="seeDemo">
          <a href="http://yumso.com" target="_blank" rel="noopener noreferrer">{t('yumso.seeDemo')}</a>
        </div>
        <img loading="lazy" decoding="async" src="/images/portfolio/yumso-min.webp" className="img-responsive" alt="yumso"/>
      </ProjectWrapper>

      <ProjectWrapper>
        <ul className="list-inline">
          <li><b>{t('yumso.dateLabel')}</b> {t('yumso.dateRange')}</li>
        </ul>
      </ProjectWrapper>
    </ProjectContainer>
  );
};

export default ProjectYumso;